<template>
    <div class="OdontogramaForm">
        <v-dialog v-model="showDialogForm" fullscreen scrollable>
            <v-card :loading="cargando" :disabled="cargando">
                <v-card-title v-text="'Registrar cambios en el odontograma'" />
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <h2 class="mb8">Superior Izquierdo</h2>
                            <h5>Cuadrante I</h5>
                            <div v-for="n in ['A','B','C','D','E']" :key="n">
                                <v-text-field class="mt24" :label="n" v-model="odontograma['si' + n + '_odo']" filled append-icon="add_shopping_cart" @click:append="dienteToAdd = 'si' + n" />
                                <span v-for="(ood,idxood) in odontoCart['si' + n]" :key="idxood">
                                    {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                                    {{idxood+1>=odontoCart['si' + n].length? '':','}}
                                </span>
                                <v-divider></v-divider>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <h2 class="mb8">Superior Derecho</h2>
                            <h5>Cuadrante II</h5>
                            <div v-for="n in ['A','B','C','D','E']" :key="n">
                                <v-text-field class="mt24" :label="n" v-model="odontograma['sd' + n + '_odo']" filled append-icon="add_shopping_cart" @click:append="dienteToAdd = 'sd' + n" />
                                <span v-for="(ood,idxood) in odontoCart['sd' + n]" :key="idxood">
                                    {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                                    {{idxood+1>=odontoCart['sd' + n].length? '':','}}
                                </span>
                                <v-divider></v-divider>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <h2 class="mb8">Inferior izquierdo</h2>
                            <h5>Cuadrante IV</h5>
                            <div v-for="n in ['A','B','C','D','E']" :key="n">
                                <v-text-field class="mt24" :label="n" v-model="odontograma['ii' + n + '_odo']" filled append-icon="add_shopping_cart" @click:append="dienteToAdd = 'ii' + n" />
                                <span v-for="(ood,idxood) in odontoCart['ii' + n]" :key="idxood">
                                    {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                                    {{idxood+1>=odontoCart['ii' + n].length? '':','}}
                                </span>
                                <v-divider></v-divider>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <h2 class="mb8">Inferior derecho</h2>
                            <h5>Cuadrante III</h5>
                            <div v-for="n in ['A','B','C','D','E']" :key="n">
                                <v-text-field class="mt24" :label="n" v-model="odontograma['id' + n + '_odo']" filled append-icon="add_shopping_cart" @click:append="dienteToAdd = 'id' + n" />
                                <span v-for="(ood,idxood) in odontoCart['id' + n]" :key="idxood">
                                    {{ood.cant_sca}} x {{ood.desc_ser}}: {{$nF(ood.cant_sca*ood.precio_sca)}}
                                    {{idxood+1>=odontoCart['id' + n].length? '':','}}
                                </span>
                                <v-divider></v-divider>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text v-text="'Cancelar'" @click="showDialogForm = false" />
                    <v-btn class="primary" v-text="'Guardar'" @click="_checkHowToSaveOdontograma" />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog width="400" v-model="showDialogAddToCart">
            <v-card :loading="cargando" :disabled="cargando">
                <v-card-title v-text="'Añadir servicios al diente'" />
                <v-card-text>
                    <autocomplete-servicios v-model="cart.id_ser_sca" @change="_handleServicioChange" />
                    <v-text-field filled label="Cantidad" v-model="cart.cant_sca" type="number" min="1" />

                    <v-text-field filled label="Precio unitario" prepend-inner-icon="attach_money" v-model="cart.precio_sca" />
                    <v-btn class="primary" @click="_addCarritoDiente">
                        <v-icon>add</v-icon>
                        Agregar
                    </v-btn>
                </v-card-text>
                <v-list v-if="odontoCart[dienteToAdd] && odontoCart[dienteToAdd].length>=1">
                    <div v-for="(od,idxo) in odontoCart[dienteToAdd]" :key="idxo">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title v-text="od.desc_ser+' '+$nF(od.cant_sca*od.precio_sca)" />
                                <v-list-item-subtitle>
                                    <v-text-field
                                        v-model="od.cant_sca"
                                        type="number"
                                        min="1"
                                        dense
                                        hide-details
                                        style="max-width: 80px;"
                                        @change="_updateServiceQuantity(idxo)"
                                    />
                                    <span class="ml-2">Precio unitario: {{$nF(od.precio_sca)}}</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="_deleteCarrito(idxo)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </div>
                </v-list>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text v-text="'Cerrar'" @click="showDialogAddToCart=false" />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog width="400" v-model="showDialogConfirmCart">
            <v-card :loading="cargando" :disabled="cargando">
                <v-card-title>¿Está correcto el carrito?</v-card-title>
                <v-list>
                    <div v-for="(fc,idxfc) in finalCart" :key="idxfc">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title v-text="fc.cant_sca+' x '+fc.desc_ser" />
                            </v-list-item-content>
                            <v-list-item-action-text v-text="$nF(fc.cant_sca*fc.precio_sca)" />
                        </v-list-item>
                        <v-divider />
                    </div>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong>Total: {{$nF(total)}}</strong>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                </v-list>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text v-text="'No'" @click="showDialogConfirmCart=false" />
                    <v-btn class="primary" v-text="'Si, guardar'" @click="_guardarOdontograma" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import AutocompleteServicios from "@/components/forms/autocompletes/AutocompleteServicios.vue";
export default {
  name: "OdontogramaForm",
  mixins: [forms],
  components: { AutocompleteServicios },
  props: {
    value: Boolean,
    paciente: String,
    odontogramaToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      odontograma: {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      },
      odontoCart: {},
      finalCart: [],
      showDialogForm: false,
      showDialogAddToCart: false,
      showDialogConfirmCart: false,
      cart: {
        id_pac_sca: null,
        id_ser_sca: null,
        cant_sca: null,
        precio_sca: null,
        desc_ser: null,
        diente: null,
      },
      dienteToAdd: null,
    };
  },
  methods: {
    _checkHowToSaveOdontograma() {
      this.finalCart.length >= 1
        ? (this.showDialogConfirmCart = true)
        : this._guardarOdontograma();
    },
        _guardarOdontograma() {
        this.odontograma.id_pac_odo = this.paciente;

        const dientes = ['si', 'sd', 'ii', 'id'].flatMap(sector =>
        ['A', 'B', 'C', 'D', 'E'].map(letra => sector + letra)
        );
        dientes.forEach(diente => {
        this.odontograma[diente + '_cart_odo'] =
            this.odontoCart[diente]?.length
            ? JSON.stringify(this.odontoCart[diente])
            : null;
        });

      const data = {
        odontograma: this.odontograma,
        carrito: this.finalCart
      };

      // Si estamos editando, usar el endpoint de actualización, si no, usar el de creación
      console.log('Datos odontogramaToEdit:', this.odontogramaToEdit);
      if (this.odontogramaToEdit && this.odontogramaToEdit.id_odo) {
        // Para actualización
        this.odontograma.id_odo = this.odontogramaToEdit.id_odo;
        this._saveAll(
          `odontogramainfantil/${this.odontogramaToEdit.id_odo}`,
          data,
          "msg",
          "_handleOdontogramaResponse"
        );
      } else {
        // Para creación
        this._saveAll(
          "odontogramainfantil",
          data,
          "msg",
          "_handleOdontogramaResponse"
        );
      }
    },
    _handleOdontogramaResponse(res) {
      console.log('Respuesta del guardado:', res);
      this.$emit("updated", true);
      this.$emit("input", false);
      this.$emit("msg", res.msg || "Odontograma Infantil guardado correctamente");
      this._resetForm();
    },
    _resetForm() {
      this.showDialogForm = false;
      this.showDialogAddToCart = false;
      this.showDialogConfirmCart = false;
      this._createCleanOdontograma();
      this._limpiarCart();
      this.finalCart = [];
      this.dienteToAdd = null;
    },
    _createCleanOdontograma() {
      // Reiniciar el odontograma con campos base
      this.odontograma = {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      };

      // Reiniciar el carrito y los campos de cada diente
      
      this.odontoCart = {};
      const arrayLetras = ['A','B','C','D','E'];
      ['si', 'sd', 'ii', 'id'].forEach(sector => {
        for (let i = 0; i < arrayLetras.length; i++) {
          const diente = sector + arrayLetras[i];
          // Usar $set para asegurar reactividad
          this.$set(this.odontograma, diente + '_odo', '');
          this.$set(this.odontograma, diente + '_cart_odo', null);
          this.$set(this.odontoCart, diente, []);
        }
      });

      console.log('Odontograma Infantil limpio creado:', this.odontograma);
    },
    _handleServicioChange(a) {
      this.cart.cant_sca = 1;
      this.cart.precio_sca = a.precio_ser;
      this.cart.desc_ser = a.desc_ser;
    },
    _addCarritoDiente() {
      let err = null;
      if (!this.cart.id_ser_sca) {
        err = "Selecciona un servicio para agregar al carrito";
      } else if (!this.cart.cant_sca || this.cart.cant_sca < 1) {
        err = "La cantidad debe ser por lo menos 1";
      } else if (!this.cart.precio_sca || this.cart.precio_sca <= 0) {
        err = "El precio no puede ser negativo";
      }

      if (err) {
        this.$emit("msg", err);
        return false;
      }

      if (!this.odontoCart[this.dienteToAdd]) {
        this.odontoCart[this.dienteToAdd] = [];
      }

      this.odontoCart[this.dienteToAdd].push({
        id_pac_sca: this.paciente,
        id_ser_sca: this.cart.id_ser_sca,
        cant_sca: this.cart.cant_sca,
        precio_sca: this.cart.precio_sca,
        desc_ser: this.cart.desc_ser,
        diente: this.dienteToAdd
      });

      this._getTotalCart();
      this.$emit("msg", "Servicio añadido al diente " + this.dienteToAdd);
      this._limpiarCart();
    },
    _limpiarCart() {
      Object.keys(this.cart).forEach((e) => {
        this.cart[e] = null;
      });
    },
    _deleteCarrito(idx) {
      this.odontoCart[this.dienteToAdd].splice(idx, 1);
      this._getTotalCart();
      this.$emit("msg", "Servicio eliminado");
      this._limpiarCart();
    },
    _updateServiceQuantity(idx) {
      // Validar que la cantidad sea válida
      if (this.odontoCart[this.dienteToAdd][idx].cant_sca < 1) {
        this.odontoCart[this.dienteToAdd][idx].cant_sca = 1;
      }
      
      this._getTotalCart();
      this.$emit("msg", "Cantidad actualizada");
    },
    _getTotalCart() {
      let cartToAdd = [];
      Object.keys(this.odontoCart).forEach(diente => {
        if (this.odontoCart[diente] && this.odontoCart[diente].length >= 1) {
          cartToAdd = cartToAdd.concat(
            this.odontoCart[diente].map(item => ({
              ...item,
              diente: diente
            }))
          );
        }
      });
      this.finalCart = cartToAdd;
    },
    _getOdontograma() {
      if (this.odontogramaToEdit && this.odontogramaToEdit.id_odo) {
        console.log('Cargando odontograma Infantil:', this.odontogramaToEdit);
        this._getThings(
          "odontogramainfantil/" + this.odontogramaToEdit.id_odo,
          "odontograma",
          "",
          "_handleOdontogramaLoaded"
        );
      }
    },
    _handleOdontogramaLoaded(body) {
      console.log('Datos del odontograma infantil recibidos:', body);

      // El body contiene todo el objeto de respuesta, accedemos al odontograma
      const response = body.odontograma || body;
      
      console.log('Response procesado:', response);

      // Limpiar el formulario antes de cargar nuevos datos
      this._createCleanOdontograma();

      // Copiar los campos base
      this.odontograma = {
        ...this.odontograma, // Mantener la estructura base
        id_odo: response.id_odo,
        id_pac_odo: response.id_pac_odo,
        id_usr_odo: response.id_usr_odo,
        fecha_odo: response.fecha_odo,
      };
      // Cargar los campos de cada diente
       const arrayLetras = ['A','B','C','D','E'];
      ['si', 'sd', 'ii', 'id'].forEach(sector => {
        for (let i = 0; i < arrayLetras.length; i++) {
          const diente = sector + arrayLetras[i];
          const odoKey = diente + '_odo';
          const cartKey = diente + '_cart_odo';

          // Cargar las anotaciones del diente
          if (response[odoKey] !== undefined) {
            this.$set(this.odontograma, odoKey, response[odoKey]);
          }

          // Inicializar el carrito para este diente
          this.$set(this.odontoCart, diente, []);

          // Si hay datos del carrito en el odontograma, cargarlos
          if (response[cartKey]) {
            console.log(`Procesando carrito para ${diente}:`, response[cartKey]);
            try {
              const carritoData = JSON.parse(response[cartKey]);
              console.log(`Carrito parseado para ${diente}:`, carritoData);
              this.$set(this.odontoCart, diente, carritoData);
            } catch (e) {
              console.error('Error parsing cart for', diente, e);
            }
          }
        }
      });

      // Actualizar el carrito final
      this._getTotalCart();

      console.log('Odontograma cargado:', this.odontograma);
      console.log('Carrito cargado:', this.odontoCart);
    },
  },
  created() {
    this._createCleanOdontograma();
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        console.log('value changed:', newVal);
        this.showDialogForm = newVal;
      }
    },
    odontogramaToEdit: {
      immediate: true,
      handler(newVal) {
        console.log('odontogramaToEdit changed:', newVal);
        if (newVal && newVal.id_odo) {
          this._getOdontograma();
        } else {
          this._createCleanOdontograma();
        }
      }
    },
    showDialogForm(newVal) {
      console.log('showDialogForm changed:', newVal);
      this.$emit("input", newVal);
      console.log('Emitted input event with value:', newVal);
      if (!newVal) {
        this._resetForm();
      }
    },
    showDialogAddToCart(a) {
      if (!a) {
        this.dienteToAdd = null;
        this._limpiarCart();
      }
    },
    dienteToAdd(a) {
      if (a) this.showDialogAddToCart = true;
    },
  },
  computed: {
    total() {
      let subtotal = 0;
      this.finalCart.forEach((fc) => {
        subtotal = subtotal + fc.cant_sca * fc.precio_sca;
      });
      console.log("subtotal: " + subtotal);
      return subtotal;
    },
  },
};
</script>
